import HeroSection from "../components/home/Hero.jsx";
import Video from "../components/home/Video.jsx";
import WhyAgoraVoice from "../components/home/WhyAgoraVoice.jsx";
import VoiceAssistant from "../components/home/VoiceAssistant.jsx";
import GetStarted from "../components/home/GetStarted.jsx";
import Testimonial from "../components/home/Testimonials.jsx";
import TryItNow from "../components/home/TryItNow.jsx";
import PricingPlans from "../components/home/PricingPlans.jsx";
import AgentCard from "../components/home/AgentCard.jsx";
import Navbar from "../components/Navbar.jsx";
import Footer from "../components/Footer.jsx";

import { useEffect } from "react";
import { scroller, Element } from "react-scroll";
import { useLocation } from "react-router-dom";

const Home = () => {
  const location = useLocation();

  useEffect(() => {
    if (location.state?.scrollTo) {

      setTimeout(() => {
        scroller.scrollTo(location.state.scrollTo, {
          duration: 600,
          smooth: true,
          offset: -80,
        });
      }, 200);

      window.history.replaceState({}, document.title);
    }
  }, [location]);

  return (
    <div>
      <Navbar />

      <HeroSection />
      <Video />

      <Element name="features">
        <WhyAgoraVoice />
      </Element>

      <Element name="usecase">
        <VoiceAssistant />
      </Element>

      <Element name="howItWorks">
        <GetStarted />
      </Element>

      <Testimonial />
      <TryItNow />

      <Element name="pricing">
        <PricingPlans />
      </Element>

      <AgentCard />
      <Footer />
    </div>
  );
};

export default Home;
